<fui-page>
    <fui-page-pane>
        <fui-page-body>
            <fui-page-main>
                <fui-page-subject>
                    <div class="tpilb">
                        <fui-pos-logo id="logo" [type]="'fedelta'"></fui-pos-logo>
                    </div>
                </fui-page-subject>
            </fui-page-main>
        </fui-page-body>
    </fui-page-pane>
</fui-page>
